import React, {
	useState,
	useEffect,
	useLayoutEffect,
	useRef,
	useContext,
	useCallback,
} from 'react';
import { useLocation } from 'react-router-dom';

// External components
import { MdOutlineClose } from 'react-icons/md';
import KeyboardEventHandler from 'react-keyboard-event-handler';

import { OuterClick } from 'react-outer-click';
import Highlighter from 'react-highlight-words';

// Internal components
import ListV2 from 'components/Landinger/ListV2';
import Logo from 'components/Logo';
// Internal components
import Gmap from 'components/Landinger/map/GmapV5';
import { UmbracoContext } from 'contexts/Umbraco';
import { RiSideBarFill } from 'react-icons/ri';

const Landinger = () => {
	// BG VARS

	const {
		allProjects,
		ongoingProjects,
		referenceProjects,
		screenHeight,
		screenWidth,
		isTouch,
	} = useContext(UmbracoContext);

	const [dataAllProjects, setDataAllProjects] = useState(null);

	useEffect(() => {
		if (allProjects) {
			setDataAllProjects(allProjects);
		}
	}, [allProjects]);
	const [arrayToRenderInTheMap, setArrayToRenderInTheMap] =
		useState(dataAllProjects);

	const useQuery = () => {
		return new URLSearchParams(useLocation().search);
	};
	let query = useQuery();
	let viewQuery = query.get('visning');
	useLayoutEffect(() => {
		if (viewQuery) {
			if (viewQuery.toLowerCase() === 'pagaende') {
				setView('active-project');
				setDataAllProjects(ongoingProjects);
			} else if (viewQuery.toLowerCase() === 'referanse') {
				setView('reference-project');
				setDataAllProjects(referenceProjects);
			}
		} else {
			setView('allprojects');
			setDataAllProjects(allProjects);
		}
	}, [allProjects, ongoingProjects, referenceProjects, viewQuery]);

	// the search bar in sidemenu
	const [searchQuery, setSearchQuery] = useState('');

	// Set on click as active
	const [activeVessel, setActiveVessel] = useState(null);

	// Change view
	const [view, setView] = useState('allprojects');

	// Show harbour modal info box
	const [showHarbourInfoBox, setShowHarbourInfoBox] = useState(false);

	// Map view
	const [showingEntireMap, setShowingEntireMap] = useState(true);
	const [sidebarOpen, setSidebarOpen] = useState(true);

	// test data

	let searchBox = useRef(null);

	const filterBySearch = useCallback(
		(currentView, query, dataToSearch, stateFunction) => {
			if (currentView && dataToSearch?.length > 0) {
				if (query !== '' && query.length > 2) {
					let filtered = dataToSearch.filter((item) =>
						JSON.stringify(item).toLowerCase().includes(query.toLowerCase())
					);
					stateFunction(filtered);
				} else {
					stateFunction(dataToSearch);
				}
			}
		},
		[]
	);

	// Filter all by search query
	useEffect(() => {
		filterBySearch(
			view,
			searchQuery,
			dataAllProjects,
			setArrayToRenderInTheMap
		);
	}, [view, searchQuery, dataAllProjects, filterBySearch]);

	// Highlight searchquery match in search result
	const getHighlighted = (val) => {
		let q = searchQuery.toLowerCase();
		if (q.length > 2) {
			return (
				<Highlighter
					activeClassName='landinger__highlighted'
					highlightClassName='landinger__highlighted'
					searchWords={q.includes(' ') ? q.split(' ') : [q]}
					autoEscape={true}
					textToHighlight={val}
				/>
			);
		} else {
			return val;
		}
	};

	const [resetMapView, setResetMapView] = useState();

	// Focus searchbar function (only if not touch)
	const focusSearchBar = useCallback(() => {
		if (!isTouch) {
		}
	}, [isTouch]);

	const ListFooter = () => (
		<div>
			{!searchQuery ? (
				<p className=' sidebar-footer-text'>Nå har du nådd bånn.</p>
			) : (
				<></>
			)}
		</div>
	);

	/* useEffect(() => {
		if (dataAllProjects !== null) {
			setView('allprojects');
			setArrayToRenderInTheMap(dataAllProjects);
		}
	}, []); */

	const [scrollIndex, setScrollIndex] = useState(null);
	useEffect(() => {
		if (view !== 'harbours') {
			setScrollIndex(null);
		}
	}, [view]);

	//Render
	if (!allProjects)
		return (
			<div className='loading-screen'>
				<p>Laster inn kart...</p>;
			</div>
		);
	if (!arrayToRenderInTheMap) {
	}

	return (
		<>
			<KeyboardEventHandler
				handleKeys={['esc']}
				onKeyEvent={() => {
					setShowHarbourInfoBox(false);
					setSidebarOpen(false);
				}}>
				<div
					style={{ backgroundColor: '#4A4949' }}
					className={`landinger ${
						sidebarOpen ? 'landinger--sidebar-open' : ''
					}`}>
					<div
						className={`landinger__logo ${
							!showingEntireMap ||
							showHarbourInfoBox ||
							view === 'vessels' ||
							view === 'species'
								? 'hide'
								: 'show'
						}`}>
						<Logo color='white' />
					</div>
					<OuterClick
						onOuterClick={() =>
							sidebarOpen && screenWidth < 900 && isTouch
								? setSidebarOpen(false)
								: null
						}>
						{!sidebarOpen && (
							<div
								id='landinger-btn'
								className='landinger__sidebar-toggler project-map__sidebar-toggler '
								onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
									if (isTouch) {
										setSidebarOpen(!sidebarOpen);
									}
								}}
								onMouseDown={(e) => {
									e.preventDefault();
									e.stopPropagation();
									if (!isTouch) {
										setSidebarOpen(!sidebarOpen);
									}
								}}>
								<div
									style={{
										backgroundColor: 'white',
										/* 		padding: '12px 12px 12px 12px', */
									}}
									className='btn bg-white rounded-pill shadow sidebar-hide-menu'>
									<RiSideBarFill /> {sidebarOpen ? <p>y</p> : <p>Vis meny</p>}
								</div>
							</div>
						)}

						<div
							id='landinger-sidebar'
							className={`landinger__sidebar ${
								sidebarOpen ? 'landinger__sidebar--open' : ''
							}`}>
							<div id='landinger__sidebar-negative-height'>
								<div
									className='px-3 landinger__sidebar__content project-map__sidebar__content'
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										fontSize: '2em',
									}}>
									<div
										id='landinger-btn'
										className='landinger__sidebar-toggler project-map__sidebar-toggler '
										style={
											sidebarOpen
												? {
														position: 'unset',
														alignSelf: 'center',
														paddingLeft: '0',
												  }
												: {}
										}
										onClick={(e) => {
											e.preventDefault();
											e.stopPropagation();
											if (isTouch) {
												setSidebarOpen(!sidebarOpen);
											}
										}}
										onMouseDown={(e) => {
											e.preventDefault();
											e.stopPropagation();
											if (!isTouch) {
												setSidebarOpen(!sidebarOpen);
											}
										}}>
										<div
											style={
												{
													/* color: '#fdc300', backgroundColor: 'white' */
												}
											}
											className='btn bg-white rounded-pill shadow sidebar-hide-menu
											'>
											<RiSideBarFill />{' '}
											{sidebarOpen ? (
												screenWidth > 800 ? (
													<p>Skjul meny</p>
												) : (
													<p>Skjul </p>
												)
											) : (
												<p>Vis meny</p>
											)}
										</div>
									</div>
									<p
										className='landinger__sidebar__header'
										/* 	style={{
											display: 'flex',
											justifyContent: 'space-between',
											fontSize: '2em',
											color: '#fff',
										}} */
									>
										<span>Prosjekter</span>
									</p>
								</div>
								{/* Desktop buttons */}
								{screenWidth >= 800 && (
									<div className='landinger__buttons'>
										{/* Filter buttons */}
										{/* 		{searchQuery.length > 0 ? (
										<p>Tøm søkefeltet for å filtrere på prosjekttype</p>
									) : ( */}
										<>
											{' '}
											<div className='landinger__buttons__toggle--fullwidth '>
												<span
													style={
														view === 'allprojects'
															? {
																	background:
																		'linear-gradient(-15deg, #000000,#252525, #464646)',
																	color: 'rgb(255, 255, 255)',
																	backgroundSize: '100%',
															  }
															: {}
													}
													className={`btn btn--has-icon project-toggle-button ${
														view === 'allprojects'
															? 'btn-primary project-toggle-button--active'
															: 'btn-light'
													}`}
													onClick={(e) => {
														e.preventDefault();
														e.stopPropagation();
														if (isTouch) {
															setView('allprojects');
															setDataAllProjects(allProjects);

															focusSearchBar();
														}
													}}
													onMouseDown={(e) => {
														e.preventDefault();
														e.stopPropagation();
														if (!isTouch) {
															setDataAllProjects(allProjects);

															setView('allprojects');
														}
													}}>
													Alle prosjekter
												</span>
											</div>
											<div className='landinger__buttons__toggle'>
												<span
													className={`btn btn--has-icon project-toggle-button  ${
														view === 'active-project'
															? 'btn-primary project-toggle-button--active'
															: 'btn-light'
													}`}
													style={
														view === 'active-project'
															? {
																	background:
																		'linear-gradient(-2deg,rgb(243 156 30),rgb(253, 195, 0),rgb(255 236 171))',
																	color: '#372504',
															  }
															: {}
													}
													onClick={(e) => {
														e.preventDefault();
														e.stopPropagation();
														if (isTouch) {
															setView('active-project');
															setDataAllProjects(ongoingProjects);
															focusSearchBar();
														}
													}}
													onMouseDown={(e) => {
														e.preventDefault();
														e.stopPropagation();
														if (!isTouch) {
															setDataAllProjects(ongoingProjects);

															setView('active-project');
														}
													}}>
													Pågående
												</span>

												<span
													className={`btn btn--has-icon project-toggle-button ${
														view === 'reference-project'
															? 'btn-primary project-toggle-button--active'
															: 'btn-light'
													}`}
													style={
														view === 'reference-project'
															? {
																	background:
																		'linear-gradient(-2deg, rgb(106, 14, 19), rgb(172, 23, 32), rgb(218, 41, 52)) rgb(172, 23, 32)',
																	color: '#fff',
															  }
															: {}
													}
													onClick={(e) => {
														e.preventDefault();
														e.stopPropagation();
														if (isTouch) {
															setView('reference-project');
															setDataAllProjects(referenceProjects);
															focusSearchBar();
														}
													}}
													onMouseDown={(e) => {
														e.preventDefault();
														e.stopPropagation();
														if (!isTouch) {
															setDataAllProjects(referenceProjects);

															setView('reference-project');
														}
													}}>
													Referanse
												</span>
											</div>
										</>
									</div>
								)}
								{/* Mobile buttons */}
								{screenWidth < 800 && (
									<div className='landinger__buttons'>
										{/* Filter buttons */}

										<>
											{' '}
											<div className='landinger__buttons__toggle--fullwidth landinger-buttons-mobile '>
												<span
													style={
														view === 'allprojects'
															? {
																	background:
																		'linear-gradient(-15deg, #000000,#252525, #464646)',
																	color: 'rgb(255, 255, 255)',
																	backgroundSize: '100%',
															  }
															: {}
													}
													className={`btn btn--has-icon project-toggle-button mobile-filter-button ${
														view === 'allprojects'
															? 'btn-primary project-toggle-button--active'
															: 'btn-light'
													}`}
													onClick={(e) => {
														e.preventDefault();
														e.stopPropagation();
														if (isTouch) {
															setView('allprojects');
															setDataAllProjects(allProjects);

															focusSearchBar();
														}
													}}
													onMouseDown={(e) => {
														e.preventDefault();
														e.stopPropagation();
														if (!isTouch) {
															setDataAllProjects(allProjects);

															setView('allprojects');
														}
													}}>
													Alle
												</span>

												<span
													className={`btn btn--has-icon project-toggle-button mobile-filter-button ${
														view === 'active-project'
															? 'btn-primary project-toggle-button--active'
															: 'btn-light'
													}`}
													style={
														view === 'active-project'
															? {
																	background:
																		'linear-gradient(-2deg,rgb(243 156 30),rgb(253, 195, 0),rgb(255 236 171))',
																	color: '#372504',
															  }
															: {}
													}
													onClick={(e) => {
														e.preventDefault();
														e.stopPropagation();
														if (isTouch) {
															setView('active-project');
															setDataAllProjects(ongoingProjects);
															focusSearchBar();
														}
													}}
													onMouseDown={(e) => {
														e.preventDefault();
														e.stopPropagation();
														if (!isTouch) {
															setDataAllProjects(ongoingProjects);

															setView('active-project');
														}
													}}>
													Pågående
												</span>

												<span
													className={`btn btn--has-icon project-toggle-button mobile-filter-button ${
														view === 'reference-project'
															? 'btn-primary project-toggle-button--active'
															: 'btn-light'
													}`}
													style={
														view === 'reference-project'
															? {
																	background:
																		'linear-gradient(-2deg, rgb(106, 14, 19), rgb(172, 23, 32), rgb(218, 41, 52)) rgb(172, 23, 32)',
																	color: '#fff',
															  }
															: {}
													}
													/* 				ontouchstart={() => showOutlineOnTouch()}
													ontouchend={() => hideOutlineOnTouch()} */
													onClick={(e) => {
														e.preventDefault();
														e.stopPropagation();
														if (isTouch) {
															setView('reference-project');
															setDataAllProjects(referenceProjects);
															focusSearchBar();
														}
													}}
													onMouseDown={(e) => {
														e.preventDefault();
														e.stopPropagation();
														if (!isTouch) {
															setDataAllProjects(referenceProjects);

															setView('reference-project');
														}
													}}>
													Referanse
												</span>
											</div>
										</>
									</div>
								)}
								<label
									className='landinger__search project-map__search'
									style={{ display: 'block' }}>
									<input
										ref={searchBox}
										type='search'
										onChange={(e) => {
											setSearchQuery(e.target.value);
										}}
										placeholder='Søk'
										id='landinger__search'
										className='landinger__search__input selected-search-field form-control text-left pl-3 project-map__search__input'
										aria-label='Søk i leveringsstatistikk'
										aria-describedby='search-icon'
									/>

									{searchQuery.length > 0 && (
										<div
											className='landinger__search__icon--close'
											onClick={(e) => {
												e.preventDefault();
												e.stopPropagation();
												if (isTouch) {
													searchBox.current.value = '';
													setSearchQuery('');
												}
											}}
											onMouseDown={(e) => {
												e.preventDefault();
												e.stopPropagation();
												if (!isTouch) {
													searchBox.current.value = '';
													setSearchQuery('');
												}
											}}>
											<MdOutlineClose />
										</div>
									)}
								</label>
							</div>
							<div
								style={{
									height: `${
										screenHeight -
										50 -
										document.getElementById(
											'landinger__sidebar-negative-height'
										)?.offsetHeight
									}px`,
								}}>
								{view === 'allprojects' && arrayToRenderInTheMap && (
									<ListV2
										array={arrayToRenderInTheMap}
										Footer={() => <ListFooter />}
										activeItem={activeVessel}
										setActiveItem={setActiveVessel}
										setSidebarOpen={setSidebarOpen}
										getHighlighted={getHighlighted}
										searchQuery={searchQuery}
									/>
								)}
								{view === 'active-project' && arrayToRenderInTheMap && (
									<>
										<ListV2
											array={arrayToRenderInTheMap}
											scrollIndex={scrollIndex}
											Footer={() => <ListFooter />}
											activeItem={activeVessel}
											setActiveItem={setActiveVessel}
											setSidebarOpen={setSidebarOpen}
											getHighlighted={getHighlighted}
											searchQuery={searchQuery}
										/>
									</>
								)}
								{view === 'reference-project' && arrayToRenderInTheMap && (
									<>
										<ListV2
											array={arrayToRenderInTheMap}
											Footer={() => <ListFooter />}
											activeItem={activeVessel}
											setActiveItem={setActiveVessel}
											setSidebarOpen={setSidebarOpen}
											getHighlighted={getHighlighted}
											searchQuery={searchQuery}
										/>
									</>
								)}
							</div>
						</div>
					</OuterClick>

					{/* MAP */}

					<>
						<Gmap
							removeActiveProject={() => setActiveVessel(null)}
							zoom={100}
							center={{
								lat: 59.03,
								lng: 7.47,
							}}
							showingEntireMap={showingEntireMap}
							setShowingEntireMap={setShowingEntireMap}
							openInfoBox={(val) => setShowHarbourInfoBox(val)}
							view={view}
							resetMapView={resetMapView}
							markers={arrayToRenderInTheMap}
							sidebarOpen={sidebarOpen}
							infoBoxOpen={showHarbourInfoBox}
							setResetMapView={setResetMapView}
							activeItem={activeVessel}
							onChildClick={(item) => {
								if (activeVessel && activeVessel.id === item.id) {
									setActiveVessel(null);
								} else {
									setTimeout(() => {
										setActiveVessel(item);
										setScrollIndex(
											dataAllProjects.findIndex((p) => p.name === item.name) + 2
										);
									}, view === 'allprojects');
								}
							}}
						/>
					</>
				</div>
			</KeyboardEventHandler>
			<style>.project-map-sidebar-toggler {}</style>
		</>
	);
};

export default Landinger;
